<template>
<div class="shopping-cart--basket">
    <div class="row">
        <div class="col-12 text-center">
            <br><br>
            <h2>{{$t('cart.title')}}</h2>
            <br>
        </div>
    </div>
    <div v-if="items.length" class="row tableHeader d-none d-sm-flex">
        <div class="col-5 col-lg-6">{{$t('cart.checkout.table_header.products_in_cart')}}</div>
        <div class="col-3 col-lg-2 text-center">{{$t('cart.checkout.table_header.ordering')}}</div>
        <div class="col-2 text-center">{{$t('cart.checkout.table_header.discount')}}</div>
        <div class="col-1 text-center">{{$t('cart.checkout.table_header.price')}}</div>
    </div>

    <div v-else class="row tableHeader">
      <div class="col text-center">
        {{$t('cart.checkout.empty_cart')}}
      </div>
    </div>

    <cart-row v-for="item in items" :key="item.id" :item="item"></cart-row>

    <div v-if="items.length" class="row">
        <div class="col-12 col-sm-6 col-md-8 text-center" v-if="shippingData">
            <div class="row justify-content-center freeDeliveryWarning">
                <div class="col-12 col-md-8">
                    <div class="text">{{$t('cart.checkout.free_delivery_text')}}</div>
                    <div class="valueLeft" v-if="coupon && coupon.free_delivery == 1">{{ (0) | positive | money }}.</div>
                    <div class="valueLeft" v-else>{{ (shippingData.freeShipping - brutto_discounted) | positive | money }}.</div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-8 text-center" v-else></div>
        <div class="col-12 col-sm-6 col-md-4 summary">
            <div class="row tableRow">
                <div class="col-7 col-sm-6">{{$t('cart.checkout.total')}}:</div>
                <div class="col-5 col-sm-6 text-right">{{ brutto | money }}</div>
            </div>
            <div class="row tableRow">
                <div class="col-7 col-sm-6">{{$t('cart.checkout.total_discount')}}:</div>
                <div class="col-5 col-sm-6 text-right">{{ discount | money }}</div>
            </div>
            <div class="row tableRow">
                <div class="col-7 col-sm-6">{{$t('cart.checkout.total_no_vat')}}:</div>
                <div class="col-5 col-sm-6 text-right">{{ netto | money }}</div>
            </div>
            <div class="row tableRow">
                <div class="col-7 col-sm-6">{{$t('cart.checkout.vat')}} ({{$t('app.vat')}} %):</div>
                <div class="col-5 col-sm-6 text-right">{{ tax | money }}</div>
            </div>
            <div v-if="false" class="row tableRow">
                <div class="col-12 padding-0">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            {{$t('cart.checkout.coupon')}}:
                        </div>
                        <input type="text" class="form-control" aria-label="" aria-describedby="basic-addon1">
                        <div class="input-group-append">
                            <button class="btn btn btn-outline-link w-100" type="button">{{$t('cart.checkout.confirm')}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row tableRow">
                <div class="col-12 padding-0">
                  <coupon-code></coupon-code>
                </div>
            </div>
            <div class="row tableRow">
                <div class="col-7 col-sm-6 total">{{$t('cart.checkout.to_pay')}}:</div>
                <div class="col-5 col-sm-6 total text-right">{{ brutto_discounted | money }}</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import CartRow from './CartRow'
import CouponCode from './CouponCode'
import { createNamespacedHelpers as nsHelper } from 'vuex'

const {
  mapState: mapCartState,
  mapGetters: mapCartGetters
} = nsHelper('cart')

const {
  mapState: mapShippingState,
  mapActions: mapShippingActions
} = nsHelper('cart/shipping')

export default {

  components: {
    CartRow,
    CouponCode
  },

  computed: {
    ...mapCartState(['items']),
    ...mapCartState(['coupon']),
    ...mapCartGetters(['count', 'total', 'brutto', 'brutto_discounted', 'netto', 'discount', 'tax']),
    ...mapShippingState({
      shippingData: 'data'
    })
  },

  methods: mapShippingActions(['requestShippingData']),

  created () {
    this.requestShippingData()
  },

  filters: {

    positive (value) {
      return value > 0 ? value : 0
    },

    money (value) {
      return parseFloat(value).toLocaleString('sl-SI', { style: 'currency', currency: 'EUR' })
    }

  }

}
</script>
